import React, { useEffect, useState } from 'react';
import Image from '../../../components/AppImage';

const ClientLogosSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const clientLogos = [
    {
      id: 1,
      name: "TechStart Inc.",
      logo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop",
      industry: "Technology"
    },
    {
      id: 2,
      name: "GreenTech Solutions",
      logo: "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?w=200&h=100&fit=crop",
      industry: "Environmental"
    },
    {
      id: 3,
      name: "Retail Plus",
      logo: "https://images.pixabay.com/photo/2016/11/29/06/15/adult-1867743_1280.jpg?w=200&h=100&fit=crop",
      industry: "Retail"
    },
    {
      id: 4,
      name: "Fashion Forward",
      logo: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=200&h=100&fit=crop",
      industry: "Fashion"
    },
    {
      id: 5,
      name: "Wellness Co.",
      logo: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=200&h=100&fit=crop",
      industry: "Health"
    },
    {
      id: 6,
      name: "B2B Solutions",
      logo: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=200&h=100&fit=crop",
      industry: "Business"
    },
    {
      id: 7,
      name: "FinanceFlow",
      logo: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=200&h=100&fit=crop",
      industry: "Finance"
    },
    {
      id: 8,
      name: "EduTech Pro",
      logo: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=200&h=100&fit=crop",
      industry: "Education"
    },
    {
      id: 9,
      name: "MedCare Systems",
      logo: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=200&h=100&fit=crop",
      industry: "Healthcare"
    },
    {
      id: 10,
      name: "PropTech Innovations",
      logo: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=200&h=100&fit=crop",
      industry: "Real Estate"
    },
    {
      id: 11,
      name: "FoodieHub",
      logo: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=200&h=100&fit=crop",
      industry: "Food & Beverage"
    },
    {
      id: 12,
      name: "SportsTech",
      logo: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=200&h=100&fit=crop",
      industry: "Sports"
    },
    {
      id: 13,
      name: "AutoDrive",
      logo: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=200&h=100&fit=crop",
      industry: "Automotive"
    },
    {
      id: 14,
      name: "TravelEase",
      logo: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=200&h=100&fit=crop",
      industry: "Travel"
    },
    {
      id: 15,
      name: "CreativeStudio",
      logo: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=200&h=100&fit=crop",
      industry: "Creative"
    },
    {
      id: 16,
      name: "LogiFlow",
      logo: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=200&h=100&fit=crop",
      industry: "Logistics"
    },
    {
      id: 17,
      name: "EnergyPlus",
      logo: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=200&h=100&fit=crop",
      industry: "Energy"
    },
    {
      id: 18,
      name: "SecureNet",
      logo: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=200&h=100&fit=crop",
      industry: "Security"
    },
    {
      id: 19,
      name: "AgriTech",
      logo: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=200&h=100&fit=crop",
      industry: "Agriculture"
    },
    {
      id: 20,
      name: "CloudVision",
      logo: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=200&h=100&fit=crop",
      industry: "Cloud Services"
    }
  ];

  // Create multiple sets for seamless scrolling
  const extendedLogos = [...clientLogos, ...clientLogos, ...clientLogos];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % clientLogos.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [clientLogos.length]);

  return (
    <section className="py-16 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-poppins text-gray-900 mb-4">
            Trusted by Leading Companies
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join over 5,000 businesses that have transformed their digital presence with FreelanceHub
          </p>
        </div>

        {/* Scrolling Logos */}
        <div className="relative overflow-hidden">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>

          {/* Logo Carousel */}
          <div className="flex animate-scroll">
            {extendedLogos.map((client, index) => (
              <div
                key={`${client.id}-${index}`}
                className="flex-shrink-0 w-48 h-24 mx-6 flex items-center justify-center group"
              >
                <div className="w-full h-full bg-gray-50 rounded-xl border border-gray-100 flex items-center justify-center p-4 group-hover:bg-gray-100 group-hover:border-gray-200 transition-all duration-300 group-hover:shadow-md">
                  <div className="w-full h-full relative overflow-hidden rounded-lg">
                    <Image
                      src={client.logo}
                      alt={`${client.name} logo`}
                      className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-300 opacity-60 group-hover:opacity-100"
                    />
                    {/* Overlay with company name */}
                    <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="text-center text-white">
                        <div className="text-sm font-semibold">{client.name}</div>
                        <div className="text-xs opacity-80">{client.industry}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Grid */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-3xl font-bold text-blue-600 mb-2">5000+</div>
            <div className="text-gray-600 font-medium">Happy Clients</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-green-600 mb-2">20+</div>
            <div className="text-gray-600 font-medium">Industries Served</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-purple-600 mb-2">98%</div>
            <div className="text-gray-600 font-medium">Client Retention</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-orange-600 mb-2">4.9/5</div>
            <div className="text-gray-600 font-medium">Average Rating</div>
          </div>
        </div>

        {/* Industry Badges */}
        <div className="mt-12">
          <div className="text-center mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Industries We Serve
            </h3>
            <p className="text-gray-600">
              Specialized expertise across diverse business sectors
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-3">
            {[
              'Technology', 'Healthcare', 'Finance', 'E-commerce', 'Education',
              'Real Estate', 'Food & Beverage', 'Automotive', 'Travel', 'Energy',
              'Manufacturing', 'Non-Profit', 'Government', 'Entertainment'
            ].map((industry, index) => (
              <span
                key={index}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-full text-sm font-medium hover:bg-blue-100 hover:text-blue-700 transition-colors duration-200 cursor-default"
              >
                {industry}
              </span>
            ))}
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 bg-gray-50 rounded-3xl p-8">
          <div className="text-center mb-8">
            <h3 className="text-xl font-bold font-poppins text-gray-900 mb-2">
              Why Companies Choose FreelanceHub
            </h3>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div className="bg-white rounded-2xl p-6">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Vetted Professionals</h4>
              <p className="text-gray-600 text-sm">Only top 3% of freelancers pass our rigorous screening process</p>
            </div>
            
            <div className="bg-white rounded-2xl p-6">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Transparent Pricing</h4>
              <p className="text-gray-600 text-sm">No hidden fees, clear quotes, and money-back guarantee</p>
            </div>
            
            <div className="bg-white rounded-2xl p-6">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Project Management</h4>
              <p className="text-gray-600 text-sm">Dedicated managers ensure on-time, on-budget delivery</p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
        
        .animate-scroll {
          animation: scroll 60s linear infinite;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default ClientLogosSection;